import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
const View = () => {
    const [params] = useSearchParams();
    const idtb = params.get('idtb');
    const [photos, setsrc] = useState({});
    const [photodata, setdata] = useState({});
    const { idk } = useSelector((state) => state)


    const getData = async () => {
        const apikey = "cYaiLYjQHhOAt8grCTUUaiR9m2J83t0GD7T5YQI2zyKsI1TZuf0MX0tp";
        const app = await fetch(`https://api.pexels.com/v1/photos/${idtb}`, {
            headers: { Authorization: apikey }
        })
        if (app) {
            let res = await app.json()
            setsrc(res.src)

            setdata(res)
        }
    }


    const download = async () => {
        const imageUrl = photos.original; // your image URL
        const fileName = "img1.jpg";

        const response = await fetch(imageUrl);
        const blob = await response.blob();

        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = fileName;

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
    };

    const location = useLocation();

    useEffect(() => {
        getData();
    }, [])

 

    return (
        <div className='container'>
            <div className='row mt-5'>
                <div className='col-lg-6'>
                    <div> <img src={photos.original} className="img-fluid igm" /> </div>
                </div>
                <div className='col-lg-6'>
                    <div className='box mt-5'>
                        <h3 className='in-btwn'>Photo by {photodata.photographer} </h3><br />
                        <h6> Description: </h6>
                        <p> {photodata.alt} </p> <br />
                        <button className='btn btn-primary dbtn' onClick={download}> <i class="fa-solid fa-download"></i> &nbsp; &nbsp; Download </button>
                        <br />
                        <br /> 
                    </div>
                </div>
            </div>
        </div>
    );
};

export default View;